import ReactDOM from 'react-dom';
import React from 'react';
import {Provider} from "react-redux";
import store from "./DAL/store";
import MyCouponsApp from "./app/MyCouponsApp";

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('my-coupons-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <MyCouponsApp />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};